/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WindroseSpeedBucket
 */
export interface WindroseSpeedBucket {
    /**
     * 
     * @type {number}
     * @memberof WindroseSpeedBucket
     */
    from: number;
    /**
     * 
     * @type {number}
     * @memberof WindroseSpeedBucket
     */
    to: number;
    /**
     * 
     * @type {number}
     * @memberof WindroseSpeedBucket
     */
    count: number;
}

/**
 * Check if a given object implements the WindroseSpeedBucket interface.
 */
export function instanceOfWindroseSpeedBucket(value: object): value is WindroseSpeedBucket {
    if (!('from' in value) || value['from'] === undefined) return false;
    if (!('to' in value) || value['to'] === undefined) return false;
    if (!('count' in value) || value['count'] === undefined) return false;
    return true;
}

export function WindroseSpeedBucketFromJSON(json: any): WindroseSpeedBucket {
    return WindroseSpeedBucketFromJSONTyped(json, false);
}

export function WindroseSpeedBucketFromJSONTyped(json: any, ignoreDiscriminator: boolean): WindroseSpeedBucket {
    if (json == null) {
        return json;
    }
    return {
        
        'from': json['from'],
        'to': json['to'],
        'count': json['count'],
    };
}

export function WindroseSpeedBucketToJSON(json: any): WindroseSpeedBucket {
    return WindroseSpeedBucketToJSONTyped(json, false);
}

export function WindroseSpeedBucketToJSONTyped(value?: WindroseSpeedBucket | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'from': value['from'],
        'to': value['to'],
        'count': value['count'],
    };
}

